import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Crown } from "lucide-react";
import { api } from "../lib/api";
import { toast } from "sonner";

/**
 * /p/:code — Deep-link target encoded into pallet QR codes.
 * Looks up the pallet by barcode/pallet number and forwards to the detail page.
 */
export default function PalletScanRedirect() {
  const { code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get(
          `/pallets/by-number/${encodeURIComponent(code)}`
        );
        if (!cancelled) navigate(`/pallets/${data.id}`, { replace: true });
      } catch (e) {
        if (!cancelled) {
          toast.error(`No pallet found for code "${code}"`);
          navigate("/inventory", { replace: true });
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [code, navigate]);

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center gap-4 text-zinc-500"
      data-testid="pallet-scan-redirect"
    >
      <div
        className="w-12 h-12 flex items-center justify-center"
        style={{ background: "var(--mj-red)" }}
      >
        <Crown size={20} color="#E5B13A" strokeWidth={2.5} />
      </div>
      <div className="text-xs uppercase tracking-widest">
        Looking up pallet {code}…
      </div>
    </div>
  );
}
